import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { LangToggle } from "@/components/LangToggle";
import { routeForUser } from "@/lib/nav";

export default function Login() {
  const { user, login, t, formatError } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { if (user) navigate(routeForUser(user), { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      toast.success(t("member_login"));
      navigate(routeForUser(u), { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex items-center justify-between px-6 pt-6">
        <Link to="/" className="eyebrow hover:text-[color:var(--cu-gold-light)]">← Caught Up</Link>
        <LangToggle />
      </header>
      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-sm fade-up">
          <Logo size="md" />
          <h1 className="font-serif-cu text-2xl text-center mt-10 mb-8 text-[color:var(--cu-text)]">{t("member_login")}</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="eyebrow block mb-2">{t("email")}</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="cu-input w-full px-4 py-3 text-sm" autoComplete="email" />
            </div>
            <div>
              <label className="eyebrow block mb-2">{t("password")}</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="cu-input w-full px-4 py-3 text-sm" autoComplete="current-password" />
            </div>
            {error && <p data-testid="login-error" className="text-xs text-red-400">{error}</p>}
            <button data-testid="login-submit-button" disabled={loading} className="btn-gold w-full py-3.5 text-sm">{loading ? t("signing_in") : t("sign_in")}</button>
          </form>
          <div className="flex items-center justify-between mt-6">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="eyebrow hover:text-[color:var(--cu-gold-light)]">{t("forgot_password")}</Link>
            <Link to="/apply" data-testid="goto-apply-link" className="eyebrow hover:text-[color:var(--cu-gold-light)]">{t("apply_now")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
